import React, {useEffect, useState} from 'react'
import Loader from '../../assets/loader.gif'
import styles from './styles.module.scss'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {GLOBAL} from '../../Translation/English/global'

export const LoadingPage: React.FC = () => {
  const [isTimeOut, setIsTimeout] = useState(false)
  const wt = useWt()

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsTimeout(true)
    }, 3000)

    return (): void => clearTimeout(timer)
  }, [])

  return (
    <div className={styles.loadingPage} data-testid="custom-loader">
      <img width={80} height={20} src={Loader} alt="Loader" />
      {isTimeOut && <span>{wt(GLOBAL.waiting)}</span>}
    </div>
  )
}
